import { render } from "./LanguagesDropdown.vue?vue&type=template&id=05dbc07e"
import script from "./LanguagesDropdown.vue?vue&type=script&lang=js"
export * from "./LanguagesDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__